import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';

export class ClearQueryHistoryAction implements HistoryAction {
  actions = {
    [HISTORY_ACTIONS_KEYS.clearQueryHistory]: ({ commit, getters }: HistoryContext): any => {
      const storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      storageService.setItem(getters.storageKey, []);
      commit(HISTORY_MUTATIONS_KEYS.setQueryHistory, []);
    }
  };
}
